import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    redirect: '/home',
  }, {
    path: '/home',
    name: 'frontHome',
    component: () => import('../pagesF/homePage.vue')
  }, {
    path: '/backend/login',
    name: 'backLogin',
    component: () => import('../pagesB/backLogin.vue')
  }, {
    path: '/backend',
    redirect: '/backend/home',
  }, {
    path: '/backend',
    component: () => import('../pagesB/backApp.vue'),
    children: [
      {
        path: '/backend/home',
        name: 'backHome',
        component: () => import('../pagesB/backHome.vue')
      }, {
        path: '/backend/goods',
        name: 'backGoods',
        component: () => import('../pagesB/backGoods.vue')
      }, {
        path: '/backend/orders',
        name: 'backOrders',
        component: () => import('../pagesB/backOrders.vue')
      }, {
        path: '/backend/transaction',
        name: 'backTransaction',
        component: () => import('../pagesB/backTransaction.vue')
      }, {
        path: '/admin/users',
        name: 'adminUsers',
        component: () => import('../pagesA/adminUser.vue')
      }, {
        path: '/admin/shops',
        name: 'adminShops',
        component: () => import('../pagesA/adminShops.vue')
      }, {
        path: '/admin/imgs',
        name: 'adminImgs',
        component: () => import('../pagesA/adminImgs.vue')
      }, {
        path: '/admin/loginLogs',
        name: 'adminLogs',
        component: () => import('../pagesA/adminLogs.vue')
      }, {
        path: '/admin/flows',
        name: 'adminFlows',
        component: () => import('../pagesA/adminFlows.vue')
      }, {
        path: '/admin/others',
        name: 'adminOthers',
        component: () => import('../pagesA/adminOthers.vue')
      }
    ]
  }
];

var router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;